import React from 'react';

export default function CobwebSvg({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Radial lines from corner */}
      <line x1="0" y1="0" x2="120" y2="0" stroke="#8b0000" strokeWidth="0.8" opacity="0.6" />
      <line x1="0" y1="0" x2="120" y2="30" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="0" y1="0" x2="120" y2="60" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="0" y1="0" x2="90" y2="120" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="0" y1="0" x2="60" y2="120" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="0" y1="0" x2="30" y2="120" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="0" y1="0" x2="0" y2="120" stroke="#8b0000" strokeWidth="0.8" opacity="0.6" />

      {/* Concentric web arcs */}
      <path d="M 25 0 Q 12 12 0 25" stroke="#6b0000" strokeWidth="0.7" fill="none" opacity="0.7" />
      <path d="M 55 0 Q 27 27 0 55" stroke="#6b0000" strokeWidth="0.7" fill="none" opacity="0.6" />
      <path d="M 85 0 Q 42 42 0 85" stroke="#6b0000" strokeWidth="0.7" fill="none" opacity="0.5" />
      <path d="M 110 0 Q 55 55 0 110" stroke="#6b0000" strokeWidth="0.6" fill="none" opacity="0.4" />

      {/* Spider */}
      <circle cx="70" cy="18" r="3" fill="#8b0000" opacity="0.5" />
      <line x1="67" y1="18" x2="62" y2="14" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="67" y1="18" x2="61" y2="18" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="67" y1="18" x2="62" y2="22" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="73" y1="18" x2="78" y2="14" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="73" y1="18" x2="79" y2="18" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
      <line x1="73" y1="18" x2="78" y2="22" stroke="#8b0000" strokeWidth="0.8" opacity="0.5" />
    </svg>
  );
}